export default "__VITE_ASSET__Cu_0qOX5__"